import {
  CardPreview as StyledCardPreview,
  CardHeader,
  CardChip,
  CardBrandLogo,
  CardNumber,
  CardHolderSection,
  CardLabel,
  CardHolderName,
  CardFooter,
  CardExpiry,
  CardExpiryValue,
} from "./styles";
import appColors from "../../../../styles/colors";
import {
  detectCardBrand,
  CardBrandColors,
  brandMapping,
} from "../../../../utils/creditCardBrand";

interface CardPreviewProps {
  cardNumber: string;
  holderName: string;
  expiry: string;
}

const defaultCardColors: CardBrandColors = {
  primary: appColors.text.muted,
  secondary: "#3A3B3F",
};

const CardPreview = ({ cardNumber, holderName, expiry }: CardPreviewProps) => {
  // Detecta a bandeira do cartão
  const brandInfo = detectCardBrand(cardNumber);

  // Cores padrão se não houver bandeira detectada
  const cardColors = brandInfo?.colors || defaultCardColors;

  const formatCardNumber = (number: string): string => {
    let cleaned = number.replace(/\D/g, "");
    cleaned = cleaned.padEnd(16, "*");

    // Detecta se é Amex
    const cardBrandInfo = detectCardBrand(number);
    const isAmex = cardBrandInfo?.name === brandMapping["amex"]?.name;

    let formatted = "";
    if (isAmex) {
      // Formato Amex: 0000 000000 00000
      if (cleaned.length >= 4) {
        formatted = cleaned.slice(0, 4);
      }
      if (cleaned.length > 4) {
        formatted += " " + cleaned.slice(4, 10);
      }
      if (cleaned.length > 10) {
        formatted += " " + cleaned.slice(10, 15);
      }
    } else {
      if (cleaned.length >= 4) {
        formatted = cleaned.slice(0, 4);
      }
      if (cleaned.length > 4) {
        formatted += " " + cleaned.slice(4, 8);
      }
      if (cleaned.length > 8) {
        formatted += " " + cleaned.slice(8, 12);
      }
      if (cleaned.length > 12) {
        formatted += " " + cleaned.slice(12, 16);
      }
    }

    return formatted;
  };

  // Formata a validade para MM/AA
  const formatExpiry = (exp: string): string => {
    if (!exp) return "MM/AA";
    return exp.length >= 2 ? exp : "MM/AA";
  };

  const displayName = holderName || "NOME DO TITULAR";
  const brandDisplay = brandInfo?.displayName || "";

  return (
    <StyledCardPreview
      $primaryColor={cardColors.primary}
      $secondaryColor={cardColors.secondary}
    >
      <CardHeader>
        <CardChip />
        <CardBrandLogo>{brandDisplay}</CardBrandLogo>
      </CardHeader>

      <CardNumber>{formatCardNumber(cardNumber)}</CardNumber>

      <CardFooter>
        <CardHolderSection>
          <CardLabel>Portador</CardLabel>
          <CardHolderName>{displayName}</CardHolderName>
        </CardHolderSection>

        <CardExpiry>
          <CardLabel>Validade</CardLabel>
          <CardExpiryValue>{formatExpiry(expiry)}</CardExpiryValue>
        </CardExpiry>
      </CardFooter>
    </StyledCardPreview>
  );
};

export default CardPreview;
